<div class="test-result-category-chart" *ngIf="testResult">
  <div class="stats-bar" *ngFor="let category of testResult.categoryCO2e">
    <div
      class="stats-bar__bar"
      [style.backgroundImage]="
        'url(/assets/images/' + category.category.icon + ')'
      "
      *ngIf="triggerAnimation"
      [@barAnimation]="{
        value: triggerAnimation ? 'animated' : 'init',
        params: { width: getWidth(category) }
      }"
    >
      <span class="stats-bar__label">{{ getRatio(category) }}%</span>
      <span class="tooltip"
        >{{ category.category.title }}<br />{{ category.co2e | round: -1 }} kg
        CO₂e
      </span>
    </div>
  </div>
</div>
